import { render } from "./HeroiconsSolidPhotograph.vue?vue&type=template&id=4dcc7618"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhotograph.vue"]])

export default __exports__